// extracted by extract-css-chunks-webpack-plugin
module.exports = {"serverError500":"_1x5vy1","logo":"_1fU_UL"};